import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { Router } from '@angular/router';
import { CustomerService } from '../../../core/services/customer.service';
import { AgentService } from '../../../core/services/agent.service';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';

@Component({
  selector: 'app-view-agents',
  templateUrl: './view-agents.component.html',
  styleUrls: ['./view-agents.component.scss'],
})
export class ViewAgentsComponent implements OnInit {
  breadcrumbs: any[] = [];
  searchText: any;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  agentsData: any[] = [];

  skeletonTableColumns: any[] = [
    'Agent ID',
    'Full Name',
    'Category',
    'Contact Number',
    'Email',
    'Created Date',
    'Actions',
  ];
  loading = false;

  constructor(
    private router: Router,
    private agentService: AgentService,
  ) {}

  ngOnInit() {
    this.setBreadcrumbs();
    this.getPagedAgents();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedAgents();
  }

  getPagedAgents(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
      },
    });
    this.agentService.getPagedAgents(payload).subscribe((res: any) => {
      this.loading = false;
      this.agentsData = res[0].data;
      this.pageSize.length = res[0].metadata[0]?.total;
    });
  }

  search(): void {
    this.getPagedAgents();
  }

  resetSearch(): void {
    this.searchText = null;
    this.getPagedAgents();
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: `Agents`,
        route: '/admin/agents',
      },
    ];
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedAgents();
  }

  deleteAgent(id: any): void {
    this.agentService.deleteAgent(id).subscribe(() => {
      this.ngOnInit();
    });
  }

  cancel(): void {}
  editNavigate(id?: any): void {
    if (id) {
      this.router.navigate([`admin/agents/add-edit/${id}`]);
    } else {
      this.router.navigate([`admin/agents/add-edit`]);
    }
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
}
